import { Box, type BoxProps, forwardRef } from '@chakra-ui/react-v2';

import { useEmptyStyles } from './EmptyStylesContext';

export type EmptyDescriptionProps = BoxProps;

/**
 * A byline used to explain how to resolve an empty state. Part of the multipart `Empty` component. Composes `Box`.
 */
export const EmptyDescription = forwardRef<EmptyDescriptionProps, 'div'>(
  ({ children, ...restProps }, ref) => {
    const { description: descriptionStyles } = useEmptyStyles();

    return (
      <Box ref={ref} __css={descriptionStyles} {...restProps}>
        {children}
      </Box>
    );
  },
);
EmptyDescription.displayName = 'EmptyDescription';
